import jquery from 'jquery';

// @ts-ignore
export default window.$ = window.jQuery = jquery;
